import tw from 'tailwind-styled-components';

interface PageGridContainerProps {
  $maxW?: string;
}

export const PageInnerContent = tw.div`
    m-0
    p-0
`;

export const PageGridContainer = tw.div<PageGridContainerProps>`
    ${(p) => (p.$maxW ? p.$maxW : 'max-w-[72rem]')}
    m-[0_auto]
    sm:p-0
    md:p-[1rem_3.1rem]
    lg:p-[1rem_3.1rem]
    xl:p-[1rem_3.1rem]
`;

export const PagePageContent = tw.div`
    sm:p-[0_10px]
    md:px-0
    m-0
    p-0
`;

export const PageChildPages = tw.div`
    m-0
    p-0
`;
